import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FileServiceClient, MassiveDeliveryServiceClient, MassiveDeliveryServiceNewClient, CountryServiceClient, CityServiceNewClient, CompanyServiceNewClient, ClientPointServiceClient } from '../shared/api/gen_api_client/RoutingServiceClientPb';
import {
  GetFileSignedUrlRequest,
  ListMassiveDeliveryRequest,
  StatusType,
  PaginationRequest,
  DeliveryFilter,
  DeliveryStatusType,
  ListMassiveDeliveryServiceRequest,
  RouteRequest,
  GetMassiveDeliveryRequest,
  ListMassiveDeliveryServiceCoordsRequest,
  UpdateMassiveDeliveryServiceRequest,
  MassiveDeliveryServiceDetail,
  ListMassiveDeliveryNewRequest,
  ListCountriesRequest,
  ListCountriesResponse,
  ListCitiesNewRequest,
  ListCitiesResponse,
  ListMassiveDeliverCompaniesNewRequest,
  ListMassiveDeliverCompaniesResponse,
  ListDistributionCenterRequest,
  ListDistributionCenterResponse,
  UpdateMassiveDeliveryServiceNewRequest,
  MassiveDeliveryServiceNewDetail,
  UpdateMassiveDeliveryServiceNewResponse,
  DeliveryNewFilter,
  Localities,
  Sizes,
  ListDeliveryPackageSizeRequest,
  PackageSizes,
  ListLocalitiesRequest,
  LocalitiesList,
  RouteNewRequest,
  MassiveDeliveryPackageNewRequest
} from '../shared/api/gen_api_client/routing_pb';
import { GrpcFactoryService } from '../shared/sharedServices/grpc-factory.service';
import { RequestFilters } from './models/requestFilters.model';
import { RequestDataList } from './models/requestDataList.model';
import { ServicesFilters } from './models/servicesFilters.model';
import { ServiceDataList } from './models/serviceDataList.model';
import { Request } from './models/request.interface';
import { MU_ROW_INDEX } from '../shared/types/tableColumn.type';
import { Service } from './models/services.model';
import { UpdateServiceResult } from './models/updateServiceResult.model';
import { MuException } from '../shared/types/exception.type';
import { City, Company, Country, VehicleTypeSelectType } from '../shared/models/interface/parametrizacion.interface';
import * as grpcWeb from 'grpc-web';
import { ClientPointCompany } from './models/clientPointCompany.interface';
import { MuHttpService } from '../shared/sharedServices/mu-http.service';
import { Observable } from 'rxjs';
import { UploadFileResponse } from './models/uploadFileResponse.model';
import { DeliveriesFilters } from './models/deliveriesFilters.model';

@Injectable({
  providedIn: 'root',
})
export class MassiveService {
  private massiveService = this.grpcFactoryService.create(
    MassiveDeliveryServiceClient,
    `${environment.hostnameMassive}`,
    'MassiveDeliveryServiceClient'
  );
  private massiveNewService = this.grpcFactoryService.create(
    MassiveDeliveryServiceNewClient,
    `${environment.hostnameMassive}`,
    'MassiveDeliveryServiceNewClient'
  );
  private fileService = this.grpcFactoryService.create(FileServiceClient, `${environment.hostnameMassive}`, 'FileServiceClient');

  private getFileSignedUrlCall = this.grpcFactoryService.call(this.fileService, this.fileService.getFileSignedUrl, {
    callName: 'getFileSignedUrl',
  });
  private listMassiveDeliveryCall = this.grpcFactoryService.call(this.massiveService, this.massiveService.listMassiveDelivery, {
    callName: 'listMassiveDelivery',
  });
  private getMassiveDeliveryCall = this.grpcFactoryService.call(this.massiveService, this.massiveService.getMassiveDelivery, {
    callName: 'getMassiveDelivery',
  });
  private listMassiveDeliveryServiceCall = this.grpcFactoryService.call(
    this.massiveService,
    this.massiveService.listMassiveDeliveryService,
    {
      callName: 'listMassiveDeliveryService',
    }
  );
  private listMassiveDeliveriesCall = this.grpcFactoryService.call(
    this.massiveNewService,
    this.massiveNewService.listMassiveDeliveryService,
    {
      callName: 'listMassiveDeliveryService',
    }
  );
  private updateMassiveDeliveryServiceCall = this.grpcFactoryService.call(
    this.massiveService,
    this.massiveService.updateMassiveDeliveryService,
    {
      callName: 'updateMassiveDeliveryService',
    }
  );
  private updateMassiveDeliveriesServiceCall = this.grpcFactoryService.call(
    this.massiveNewService,
    this.massiveNewService.updateMassiveDeliveryService,
    {
      callName: 'updateMassiveDeliveryService',
    }
  );
  private listDeliveryPackageSizeCall = this.grpcFactoryService.call(
    this.massiveNewService,
    this.massiveNewService.listDeliveryPackageSize,
    {
      callName: 'listDeliveryPackageSize',
    }
  );
  private listLocalitiesCall = this.grpcFactoryService.call(
    this.massiveNewService,
    this.massiveNewService.listLocalities,
    {
      callName: 'listLocalities',
    }
  );

  private selectedVehicleTypeId: VehicleTypeSelectType;
  private hostnameApi: string;

  private cityServiceNewClient = this.grpcFactoryService.create(CityServiceNewClient, environment.hostnameMassive, 'CityServiceNewClient');
  private listCitiesNewRequest: ListCitiesNewRequest;
  private cities: City[];

  private clientCountryService = this.grpcFactoryService.create(CountryServiceClient, environment.hostnameMassive, 'CountryServiceClient');
  private listCountriesRequest: ListCountriesRequest;
  private countries: Country[];

  private companyServiceNewClient = this.grpcFactoryService.create(CompanyServiceNewClient, environment.hostnameMassive, 'CompanyServiceNewClient');
  private listMassiveDeliverCompaniesNewRequest: ListMassiveDeliverCompaniesNewRequest;
  private companies: Company[];

  private clientPointServiceClient = this.grpcFactoryService.create(ClientPointServiceClient, environment.hostnameMassive, 'ClientPointServiceClient');
  private listDistributionCenterRequest: ListDistributionCenterRequest;
  private cedis: ClientPointCompany[];

  constructor(
    private grpcFactoryService: GrpcFactoryService,
    private muHttp: MuHttpService) {
    this.hostnameApi = environment.hostnameSndBFF;
    this.listCitiesNewRequest = new ListCitiesNewRequest();
    this.listCountriesRequest = new ListCountriesRequest();
    this.listMassiveDeliverCompaniesNewRequest = new ListMassiveDeliverCompaniesNewRequest();
    this.listDistributionCenterRequest = new ListDistributionCenterRequest();
  }

  async updateMassiveDeliveryService(service: Service, requestId: number): Promise<UpdateServiceResult> {
    const request = new UpdateMassiveDeliveryServiceRequest();
    const detail = new MassiveDeliveryServiceDetail();
    detail.setRequestid(requestId + '');
    detail.setServiceid(service.serviceId);
    detail.setClientid(service.idClient);
    detail.setClientname(service.clientName);
    detail.setAddress(service.address);
    detail.setOrderid(service.orderId);
    detail.setWeight(service.weight);
    detail.setPhone(service.phone);
    detail.setStatus(service.status);
    detail.setLat(service.lat + '');
    detail.setLng(service.lng + '');
    request.setDetail(detail);
    const response = await this.updateMassiveDeliveryServiceCall(request);
    const result = response?.getStatus();
    return {
      serviceId: service.serviceId,
      lat: response.getLat(),
      lng: response.getLng(),
      allowToRoute: response.getAddresswrong() === 0,
      updated: result === 'OK',
    };
  }

  async listMassiveDelivery(filters: RequestFilters): Promise<RequestDataList> {
    try {
      const request = new ListMassiveDeliveryRequest();
      const pagination = new PaginationRequest();
      pagination.setLimit(filters.limit);
      pagination.setPage(filters.page);
      const filterRequest = new DeliveryFilter();
      filterRequest.setStatus(filters.status || DeliveryStatusType.CREATED);
      request.setFilters(filterRequest);
      request.setPagination(pagination);
      const result = await this.listMassiveDeliveryCall(request);
      if (!result || typeof result.getStatus !== 'function') {
        return environment.guardClause;
      }
      const status = result.getStatus();
      if (!status || status.getStatus() !== StatusType.SUCCESS) {
        throw new MuException({ message: status?.getMessage() });
      }
      const responsePagination = result.getPagination();
      return {
        values: result.getRequestsList().map(item => {
          return {
            id: item.getRequestid(),
            requestId: item.getRequestid(),
            cedi: item.getCedi(),
            cityName: item.getCityname(),
            company: item.getCompany(),
            startDate: item.getStartdate(),
            startTime: item.getStarttime(),
            endTime: item.getEndtime(),
            vehicleTypeName: item.getVehicletypename(),
            routed: item.getRouted(),
          };
        }),
        limit: responsePagination.getLimit(),
        page: responsePagination.getPage(),
        totalPages: responsePagination.getTotalpages(),
        totalRows: responsePagination.getTotalrows(),
      };
    } catch (e) {
      throw new MuException(e);
    }
  }

  async listMassiveDeliveryService(requestId: number, filters: ServicesFilters): Promise<ServiceDataList> {
    try {
      const request = new ListMassiveDeliveryServiceRequest();
      const pagination = new PaginationRequest();
      pagination.setLimit(filters.limit);
      pagination.setPage(filters.page);
      request.setPagination(pagination);
      request.setRequestid(requestId);
      const result = await this.listMassiveDeliveryServiceCall(request);
      if (!result || typeof result.getStatus !== 'function') {
        return environment.guardClause;
      }
      const status = result.getStatus();
      if (!status || status.getStatus() !== StatusType.SUCCESS) {
        throw new MuException({ message: status.getMessage() });
      }
      const responsePagination = result.getPagination();
      const allowRoute = result.getAddresswrong() === 0;
      return {
        values: result.getServicesList().map((item, ix) => {
          return {
            [MU_ROW_INDEX]: ix,
            idClient: item.getClientid(),
            clientName: item.getClientname(),
            address: item.getAddress(),
            lat: item.getLat(),
            lng: item.getLng(),
            phone: item.getPhone(),
            weight: item.getWeight(),
            wrongAddress: item.getStatus() === 'WRONG_ADDRESS',
            serviceId: item.getServiceid(),
            orderId: item.getOrderid(),
            status: item.getStatus(),
          };
        }),
        limit: responsePagination.getLimit(),
        page: responsePagination.getPage(),
        totalPages: responsePagination.getTotalpages(),
        totalRows: responsePagination.getTotalrows(),
        allowRoute,
      };
    } catch (e) {
      throw new MuException(e);
    }
  }

  async updateMassiveDeliveries(service: Service, countryGeoName: string, cityGeoName: string ): Promise<UpdateMassiveDeliveryServiceNewResponse> {
    const request = new UpdateMassiveDeliveryServiceNewRequest();
    const detail = new MassiveDeliveryServiceNewDetail();
    detail.setMddeliverypkgid( Number.parseInt(service.mdDeliveryPkgId) );
    detail.setClientid(service.idClient);
    detail.setOrderid(service.orderId);
    detail.setClientname(service.clientName);
    detail.setAddress(service.address);
    detail.setLat(service.lat + '');
    detail.setLng(service.lng + '');
    detail.setCountrygeoname( countryGeoName );
    detail.setCitygeoname( cityGeoName );

    request.setDetail(detail);
    const response = await this.updateMassiveDeliveriesServiceCall(request);
    return response;
  }

  async listMassiveDeliveries(companyId: number, cediId: number, filters: DeliveriesFilters): Promise<ServiceDataList> {
    try {
      let startDate, dueDate;
      if ( filters.startDate ) {
        startDate = `${filters.startDate.getFullYear()}-${(filters.startDate.getMonth() + 1)}-${(filters.startDate.getDate())}`
      }
      if ( filters.dueDate ) {
        dueDate = `${filters.dueDate.getFullYear()}-${(filters.dueDate.getMonth() + 1)}-${(filters.dueDate.getDate())}`
      }
      const localities = new Localities();
      localities.setLocalityList(filters.nameLocalities);
      const sizes = new Sizes();
      sizes.setSizeentryList(filters.idSizes);
      const newFilters = new DeliveryNewFilter();
      newFilters.setOrderid(filters.orderId);
      newFilters.setLocalities(localities);
      newFilters.setSizes(sizes);
      newFilters.setStartdate(startDate);
      newFilters.setDuedate(dueDate);
      const request = new ListMassiveDeliveryNewRequest();
      const pagination = new PaginationRequest();
      pagination.setLimit(filters.limit);
      pagination.setPage(filters.page);
      request.setPagination(pagination);
      request.setCompanyid(companyId);
      request.setCedi(cediId);
      request.setFilters(newFilters);
      const result = await this.listMassiveDeliveriesCall(request);
      if (!result || typeof result.getStatus !== 'function') {
        return environment.guardClause;
      }
      const status = result.getStatus();
      if (!status || status.getStatus() !== StatusType.SUCCESS) {
        throw new MuException({ message: status.getMessage() });
      }
      const responsePagination = result.getPagination();
      const allowRoute = result.getRequestsList().filter( value => {
        value.getIswrongaddress()
      }).length === 0;

      return {
        values: result.getRequestsList().map((item, ix) => {
          return {
            [MU_ROW_INDEX]: ix,
            idClient: item.getClientid(),
            clientName: item.getClientname(),
            address: item.getClientaddress(),
            lat: item.getLatitud(),
            lng: item.getLongitud(),
            phone: item.getClientphone(),
            weight: item.getWeight(),
            wrongAddress: item.getIswrongaddress(),
            serviceId: item.getMddeliverypkgid().toString(),
            orderId: item.getOrderid(),
            status: item.getIswrongaddress() ? 'WRONG_ADDRESS' : 'OK',
            size: item.getPackagesize(),
            received: item.getReceived(),
            createdDate: item.getCreateat(),
            deliveryDate: item.getDeliveredat(),
            locality: item.getLocality(),
            mdDeliveryPkgId: item.getMddeliverypkgid().toString(),
          };
        }),
        limit: responsePagination.getLimit(),
        page: responsePagination.getPage(),
        totalPages: responsePagination.getTotalpages(),
        totalRows: responsePagination.getTotalrows(),
        allowRoute,
      };
    } catch (e) {
      throw new MuException(e);
    }
  }

  async getFileSignedUrl(fileId: string) {
    const request = new GetFileSignedUrlRequest();
    try {
      request.setFileid(fileId);
      const result = await this.getFileSignedUrlCall(request);
      if (!result || typeof result.getStatus !== 'function') {
        return environment.guardClause;
      }
      const status = result.getStatus();
      if (!status || status.getStatus() !== StatusType.SUCCESS) {
        throw new MuException({ message: status.getMessage() });
      }
      return result.getSignedurl();
    } catch (e) {
      throw new MuException(e);
    }
  }

  async getMassiveDeliveryService(requestId: number): Promise<Request> {
    const request = new GetMassiveDeliveryRequest();
    request.setRequestid(requestId);
    const response = await this.getMassiveDeliveryCall(request);
    const item = response?.getRequest();
    return {
      requestId: item.getRequestid(),
      cedi: item.getCedi(),
      cityName: item.getCityname(),
      company: item.getCompany(),
      startDate: item.getStartdate(),
      startTime: item.getStarttime(),
      endTime: item.getEndtime(),
      vehicleTypeName: item.getVehicletypename(),
      routed: item.getRouted(),
      lat: item.getLat(),
      lng: item.getLng(),
    } as Request;
  }

  async uploadExcelFile(fileId: string, file: File) {
    const uploadUrl = await this.getFileSignedUrl(fileId);
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/octet-stream',
      },
    });
    if (response.status !== 200) {
      throw new MuException({ message: response.statusText });
    }
    return fileId;
  }

  route(requestId: number) {
    const request = new RouteRequest();
    request.setRequestid(requestId);
    return this.massiveService.route(request, {});
  }

  newRoute(
    companyId: number, 
    cityId: number, 
    cediPointId: number, 
    startDate: string, 
    startTime: string, 
    endTime: string,
    cityName: string,
    Vehicletypename: string,
    vehicletypeid: number,
    country: string,
    packageList: MassiveDeliveryPackageNewRequest ) {
    const request = new RouteNewRequest();
    request.setCompanyid(companyId);
    request.setCityid(cityId);
    request.setCedipointid(cediPointId);
    request.setStartdate(startDate);
    request.setStarttime(startTime);
    request.setEndtime(endTime);
    request.setCityname(cityName);
    request.setVehicletypename(Vehicletypename);
    request.setVehicletypeid(vehicletypeid);
    request.setCountry(country);
    request.setPackageslist(packageList);
    return this.massiveNewService.route(request, {});
  }

  listMassiveDeliveryServiceCoords(requestId: number) {
    const request = new ListMassiveDeliveryServiceCoordsRequest();
    request.setRequestid(requestId);
    return this.massiveService.listMassiveDeliveryServiceCoords(request, {});
  }

  /**
   *
   * @param vechicle VehicleTypeSelectType
   * @return void
   *
   * set the id number for the vechicle type
   */
  setTypeVehicleSelected(vechicle: VehicleTypeSelectType): void {
    this.selectedVehicleTypeId = vechicle;
  }

  /**
   *
   * @return VehicleTypeSelectType
   *
   * get the id number for the vechicle type
   */
  getTypeVehicleSelected(): VehicleTypeSelectType {
    return this.selectedVehicleTypeId;
  }

  /**
   * @description get the list of countries
   * @returns Promise<City[]>
   */
  getListCountries(): Promise<Country[]> {
    return new Promise((resolve, reject) => {
      this.clientCountryService.listCountry(this.listCountriesRequest, {}, (err: grpcWeb.Error, response: ListCountriesResponse) => {
        if (err) {
          reject(err);
        } else {
          this.countries = response?.getCountriesList()?.map(client => {
            return {
              id: client.getId(),
              name: client.getName(),
              geoName: client.getIso2(),
              iso2: client.getIso2(),
            };
          });
          resolve(this.countries);
        }
      });
    });
  }

  /**
   * @description get the list of cities for the selected country
   * @param countryIso2 string
   * @returns Promise<City[]>
   */
   getListCities(countryIso2: string): Promise<City[]> {
    this.listCitiesNewRequest.setCountry(countryIso2);
    return new Promise((resolve, reject) => {
      this.cityServiceNewClient.listCities(this.listCitiesNewRequest, {}, (err: grpcWeb.Error, response: ListCitiesResponse) => {
        if (err) {
          reject(err);
        } else {
          this.cities = response?.getCitiesList()?.map(client => {
            return {
              id: client.getId(),
              name: client.getName(),
              geoName: client.getGeoname(),
            };
          });
          resolve(this.cities);
        }
      });
    });
  }

  /**
   * @description get the list of Companies for the selected country
   * @param countryId string
   * @returns Promise<Company[]>
   */
  getListCompanies(countryIso2: string): Promise<Company[]> {
    this.listMassiveDeliverCompaniesNewRequest.setCountry(countryIso2);
    return new Promise((resolve, reject) => {
      this.companyServiceNewClient.listMassiveDeliverCompanies(this.listMassiveDeliverCompaniesNewRequest, {}, (err: grpcWeb.Error, response: ListMassiveDeliverCompaniesResponse) => {
        if (err) {
          reject(err);
        } else {
          this.companies = response?.getCompaniesList()?.map(client => {
            return {
              id: client.getId(),
              name: client.getName(),
            };
          });
          resolve(this.companies);
        }
      });
    });
  }

  /**
   * @description get the list of cedipoints.
   * @param companyId number
   * @returns Promise with a list of ClientPointCompany
   */
  getListCediPionts(companyId: number, cityId: number): Promise<ClientPointCompany[]> {
    this.listDistributionCenterRequest.setCompanyid(companyId);
    this.listDistributionCenterRequest.setCityid(cityId);
    this.listDistributionCenterRequest.setShowstores(true);
    return new Promise((resolve, reject) => {
      this.clientPointServiceClient.listDistributionCenter(this.listDistributionCenterRequest, {}, (err: grpcWeb.Error, response: ListDistributionCenterResponse) => {
        if (err) {
          reject(err);
        } else {
          this.cedis = response?.getClientpointsList()?.map(client => {
            return {
              id: client.getId(),
              companyid: client.getCompanyid(),
              name: client.getName(),
              address: client.getAddress(),
              lat: client.getLat(),
              lng: client.getLng(),
              status: client.getStatus(),
              idcity: client.getIdcity(),
              namecity: client.getNamecity(),
              isdistributioncenter: client.getIsdistributioncenter(),
            };
          });
          resolve(this.cedis);
        }
      });
    });

  }

  /*
   * ask for the CFDI file from carta porte file
   * @param file
   * @returns
   */
  getCfdiFile(file: File): Observable<UploadFileResponse> {
    let formData = new FormData();
    formData.append('file', file);
    let contentType = 'multipart/form-data';
    return this.muHttp.postFormDataFile(`${this.hostnameApi}/snd/massive-cfdi/uploadfile/`, formData, contentType);
  }

  /**
   * @description get the list of sizes.
   * @param
   * @returns Promise with a list of Sizes
   */
   async getListSizes(): Promise<PackageSizes[]> {
    const request = new ListDeliveryPackageSizeRequest();
    const result = await this.listDeliveryPackageSizeCall(request);
    if (!result || typeof result.getPackagesizeList !== 'function') {
      return environment.guardClause;
    }
    return result.getPackagesizeList();
  }

  /**
   * @description get the list of localities.
   * @param idCity
   * @returns Promise with a list of Localities
   */
   async getLocalities(idCity: number): Promise<LocalitiesList[]> {
    const request = new ListLocalitiesRequest();
    request.setIdcity(idCity);
    const result = await this.listLocalitiesCall(request);
    if (!result || typeof result.getLocalitiesList !== 'function') {
      return environment.guardClause;
    }
    return result.getLocalitiesList();
  }
}
